module.exports = __webpack_public_path__ + "img/logo_klarna.2bdd13f.svg";